module.exports = __webpack_public_path__ + "img/dialog-icon3.02531913.svg";